import styled from "styled-components";
// Strength(강점) 카드 묶음: [{ title, text }] 개수만큼 01, 02 … 카드로 보여준다.
// TriangleScope(3개)·PentagonScope(5개)도 이 컴포넌트를 그대로 쓴다.
const DiamondScope = ({ contents }) => {
  return (
    <Ul>
      {contents?.map((x, idx) => (
        <li key={idx}>
          <span className="no">{String(idx + 1).padStart(2, "0")}</span>
          <strong>{x.title}</strong>
          {x.text && <p>{x.text}</p>}
        </li>
      ))}
    </Ul>
  );
};
export default DiamondScope;
const Ul = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(13rem, 1fr));
  gap: 1rem;
  & > li {
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 0.6rem;
    padding: 1.75rem 1.5rem 1.6rem;
    border-radius: ${({ theme }) => theme.radius};
    background-color: ${({ theme }) => theme.colors.monotone.extralight};
    overflow: hidden;
    transition: transform 0.2s, box-shadow 0.2s, background-color 0.2s;
    &:before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 3px;
      background: linear-gradient(90deg, ${({ theme }) => theme.colors.accent}, ${({ theme }) => theme.colors.dark});
    }
    & > .no {
      font-size: 0.85rem;
      font-weight: 800;
      letter-spacing: 0.05em;
      color: ${({ theme }) => theme.colors.accent};
    }
    & > strong {
      font-size: 1.3rem;
      line-height: 1.35;
      font-weight: 800;
      letter-spacing: -0.02em;
      color: ${({ theme }) => theme.colors.dark};
    }
    & > p {
      margin: 0;
      font-size: 0.975rem;
      line-height: 1.65;
      color: ${({ theme }) => theme.colors.foreground.dimmed};
    }
    &:hover {
      transform: translateY(-3px);
      background-color: white;
      box-shadow: ${({ theme }) => theme.shadow.md};
    }
  }
`;
